import { createComponentProgrammatic } from './createComponentProgrammatic'


const DEFAULT_DATA = {
  titleText: 'Подтверждение',
  mainText: 'Действие отменить нельзя, Вы уверены?',
  successText: 'Действие успешно',
  errorText: 'Ошибка действия',
  cancelBtn: 'Отменить',
  successBtn: 'Подтвердить',
}

/**
 *
 * @param {*} parent
 * @param {object} propsData
 * @param {string} propsData.titleText
 * @param {string|void} propsData.mainText
 * @param {string} propsData.successText
 * @param {string} propsData.errorText
 * @param {(...any[]) => Promise<any>} propsData.action
 */
export const createModalConfirm = (parent, propsData) => {
  const AsyncComponent = import(
    /* webpackChunkName: "BModalConfirm" */
    '@/components/modals/BModalConfirm.vue'
  )

  const removePropsData = {
    ...DEFAULT_DATA,
    ...propsData,
  }

  /** @type {Promise<{ open: () => Promise<boolean>, close: (flag?: boolean) => Promise<boolean>}>} */
  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    removePropsData,
  )

  return result
}
